import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e98f1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chart-wrapper"
}

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import * as echarts from 'echarts'
import { ResizeService } from '@/services/resize.service'
import { getAssignPieOption } from '@/utils/echarts-option/pie'
import { useEchartsThemeSync } from '@/composables/use-echarts-theme-sync'
import { getOverviewPieSliceColor } from '@/views/dashboard/overview/_components/overview-pie-distribution'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PieCenter from '@/views/dashboard/_components/echarts/pie-center.vue'
import TimeRangeSelect from '@/views/dashboard/_components/time-range-select/time-range-select.vue'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { softDisableGroupList } from '../software-disabled.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-interception-distribution-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["timeRangeChange", "sliceClick"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

const props = __props

const emit = __emit

const injector = useReflectiveInjector([ResizeService])
const resizeService = injector.get(ResizeService)

const timeRange = ref<TimeRange>(TimeRange.DAYS_30)
const chartRef = ref<HTMLElement>()
let chartInstance: echarts.EChartsType | null = null

/** 与终端分布/威胁类型分布一致：无有效占比时不展示饼图 */
const hasChartData = computed(() => props.data.some(item => Number(item.percentage) > 0))

const totalPercentage = computed(() =>
  Math.round(props.data.reduce((sum, item) => sum + (Number(item.percentage) || 0), 0))
)

function initChart() {
  if (!chartRef.value) return
  chartInstance = echarts.init(chartRef.value)
  renderChart()
  nextTick(() => {
    chartInstance?.resize()
  })
}

function renderChart() {
  if (!chartInstance || !hasChartData.value) return

  const pieData = props.data.map((item, index) => ({
    name: item.name || t('commonPage.unknown'),
    rawKeyword: (item.name || '').trim(),
    groupId: item.group_id,
    value: item.percentage,
    itemStyle: { color: getOverviewPieSliceColor(item.name || '', index) },
  }))

  const option = {
    series: [{
      data: pieData,
      name: t('softwareDisabledCharts.distributionSeriesName'),
    }],
  }

  const finalOption = getAssignPieOption(option, { unit: '%' })
  chartInstance.setOption(finalOption)
  registerChartClick()
}

function registerChartClick () {
  if (!chartInstance) return
  chartInstance.off('click')
  chartInstance.on('click', (params: { componentType?: string; data?: { rawKeyword?: string; groupId?: number } }) => {
    if (params.componentType !== 'series') return
    const name = String(params.data?.rawKeyword ?? '').trim()
    const gid = params.data?.groupId
    const groupId = typeof gid === 'number' && Number.isFinite(gid) ? gid : undefined
    emit('sliceClick', { groupId, groupName: name || undefined })
  })
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  chartInstance && chartInstance.resize()
})

function handleTimeRangeChange(value: TimeRange) {
  timeRange.value = value
  emit('timeRangeChange', value)
}

watch(
  () => props.data,
  () => {
    if (!hasChartData.value) {
      chartInstance?.dispose()
      chartInstance = null
      return
    }
    if (!chartInstance) {
      nextTick(initChart)
    } else {
      renderChart()
    }
  },
  { deep: true },
)

watch(locale, () => {
  if (hasChartData.value) {
    nextTick(() => renderChart())
  }
})

useEchartsThemeSync(() => {
  if (chartInstance && hasData.value) renderChart()
})

onMounted(() => {
  if (hasChartData.value) {
    nextTick(initChart)
  }
})

onUnmounted(() => {
  resizeSubscribe.unsubscribe()
  chartInstance && chartInstance.dispose()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(Card, {
    size: "second",
    title: _unref(t)('softwareDisabledCharts.distributionTitle'),
    class: "software-interception-distribution-chart-wrap"
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    headerRight: _withCtx(() => [
      _createVNode(TimeRangeSelect, {
        modelValue: timeRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeRange).value = $event)),
        onChange: handleTimeRangeChange
      }, null, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      (hasChartData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              ref_key: "chartRef",
              ref: chartRef,
              class: "chart"
            }, null, 512),
            _createVNode(PieCenter, {
              title: _unref(t)('softwareDisabledCharts.distributionCenterLabel'),
              value: totalPercentage.value,
              unit: "%"
            }, null, 8, ["title", "value"])
          ]))
        : (_openBlock(), _createBlock(EmptyData, {
            key: 1,
            height: "360px",
            "bg-color": "transparent"
          }))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})